/**
 * We want to limit imports directly from `launchdarkly-react-client-sdk` to prevent
 * untyped feature flag usage
 */
// eslint-disable-next-line no-restricted-imports
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { type ReactNode } from 'react';

/**
 * Non dev environments should have env variable set.
 * If the env variable is not set, we will fall back to a fake Launch Darkly id.
 */
const DEV_LAUNCH_DARKLY_CLIENT_ID = '67db63af2bd59409a2eadb97';
const DEFAULT_LAUNCH_DARKLY_CLIENT_ID =
  import.meta.env.MODE === 'development'
    ? DEV_LAUNCH_DARKLY_CLIENT_ID
    : 'fake-id-for-non-dev-environments';
const { VITE_LAUNCH_DARKLY_CLIENT_ID } = import.meta.env;

interface LaunchDarklyProviderProps {
  children: ReactNode;
}
export function LaunchDarklyProvider(props: LaunchDarklyProviderProps) {
  return (
    <LDProvider clientSideID={VITE_LAUNCH_DARKLY_CLIENT_ID ?? DEFAULT_LAUNCH_DARKLY_CLIENT_ID}>
      {props.children}
    </LDProvider>
  );
}
